'use client';
import { useMemo } from 'react';
import Image from 'next/image';
import { useParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { LangLink } from '../../../i18n/links';
import { defaultLang, SUPPORTED } from '../../../config/languages';
import { COMPARE_SECTION } from '../../../config/compareSections';
import { vs } from '../vs/vs';
import WorkspaceCTA from '../../v2/WorkspaceCTA';

export default function VsLayout2() {
  const { lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;
  const section = COMPARE_SECTION[activeLang] || 'compare';
  const { t } = useTranslation('vs');
  const items = useMemo(() => vs.map((item) => {
    const tr = item.translations?.[activeLang] || item.translations?.en || item;
    return { ...item, title: tr.title || item.title, description: tr.description || item.description, slug: typeof item.slug === 'object' ? (item.slug[activeLang] || item.slug.en) : item.slug };
  }), [activeLang]);
  return <>
    <link rel="stylesheet" href="/assets/css/blog-layout-2.css" />
    <link rel="stylesheet" href="/assets/css/content-layout-2.css" />
    <link rel="stylesheet" href="/assets/css/comparison-layout-2.css" />
    <main className="blog-v2-page comparison-v2-page">
      <section className="comparison-v2-hero"><div className="container blog-v2-container"><p className="blog-v2-eyebrow">AdCast comparisons</p><h1>{t('title')}</h1><p>{t('subtitle')}</p></div></section>
      <section className="comparison-v2-list"><div className="container blog-v2-container"><div className="comparison-v2-grid">
        {items.map((item, index) => <article className="comparison-v2-card" key={item.id}>
          <LangLink to={`/${section}/${item.slug}`} className="comparison-v2-image"><Image src={item.image} alt={item.title} fill sizes="(max-width: 800px) 100vw, 50vw" /></LangLink>
          <div><span>0{index + 1}</span><h2><LangLink to={`/${section}/${item.slug}`}>{item.title}</LangLink></h2><p>{item.description}</p><LangLink to={`/${section}/${item.slug}`}>{t('readMore')} →</LangLink></div>
        </article>)}
      </div><WorkspaceCTA /></div></section>
    </main>
  </>;
}
